<template>
    <v-app style="background: transparent;" id="projects">
        <div class="projects">
            <h2 class="heading">My <span>Projects</span></h2>
            <div class="projects-container">
                <div class="project-box">
                    <img src="../assets/gvpcew_campus_connect.png" alt="">
                    <div class="project-layer" style="background: linear-gradient(rgba(0,0,0,0.6), #1d13489a);">
                        <h4><i class='bx bxl-flutter' style="color: rgb(59, 134, 219);"></i>GVPW connect</h4>
                        <p>The GVPW Feedback App streamlines student feedback at GVPCEW College through surveys, enhancing the college experience.</p>
                        <div class="link-container">
                            <a class="github" href="https://github.com/campus-connect-inc/gvpw_connect" target="_blank"><fa :icon="['fab', 'github']" size="xl" class="link" /></a>
                        </div>
                    </div>
                </div>
                <div class="project-box">
                    <img src="../assets/MoviePedia.png" alt="">
                    <div class="project-layer" style="background: linear-gradient(rgba(0,0,0,0.6), #481b1981);">
                        <h4><i class='bx bxl-flutter' style="color: rgb(59, 134, 219);"></i>MoviePedia</h4>
                        <p>MoviePedia is like a mini wikipedia only for movies, TV shows, anime etc.... using TMDB api</p>
                        <div class="link-container">
                            <a class="no-tufte-underline" href="https://drive.google.com/file/d/1AH0mGccJu9Ma655rTSj5RbNEFu2vEtVM/view?usp=drive_link" target="_blank"><fa :icon="['fas', 'arrow-up-right-from-square']" class="link"/></a>
                            <a class="github" href="https://github.com/Rohit-KK15/MoviePedia" target="_blank"><fa :icon="['fab', 'github']" size="xl" class="link" /></a>
                        </div>
                    </div>
                </div>
                <div class="project-box">
                    <img src="../assets/BingeBird.jpg" alt="">
                    <div class="project-layer" style="background: linear-gradient(rgba(0,0,0,0.6), #1e224070);">
                        <h4><i class='bx bx-bot' style="color: #4C55F7;"></i>BingeBird</h4>
                        <p>An AI-powered Telegram bot that provides movie and TV show info and helps users post reviews on X.</p>
                        <div class="link-container">
                            <a class="github" href="https://github.com/Rohit-KK15/BingeBird-Bot" target="_blank"><fa :icon="['fab', 'github']" size="xl" class="link" /></a>
                        </div>
                    </div>
                </div>
                <div class="project-box">
                    <img src="../assets/MindfulAI.png" alt="">
                    <div class="project-layer" style="background: linear-gradient(rgba(0,0,0,0.6), #1e224070);">
                        <h4><i class='bx bx-bot' style="color: #4C55F7;"></i>MindfulAI</h4>
                        <p>I integrated mental health web app with journaling, assessments, CBT techniques and an AI agent for Socratic conversations.</p>
                        <div class="link-container">
                            <a class="github" href="https://github.com/Rohit-KK15/MindfulAI" target="_blank"><fa :icon="['fab', 'github']" size="xl" class="link" /></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-app>
</template>

<script>
</script>

<style scoped>

#projects{
    height: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Poppins';
}

.projects{
    margin: 50px 10%;
}

.projects h2{
    text-align: center;
    font-size: xxx-large;
    color: #fff;
}

.projects h2 span{
    color: #4C55F7;
}

.projects-container{
    margin-top: 50px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    gap: 5rem;
}

.project-box{
    position: relative;
    border-radius: 2rem;
    box-shadow: 0 0 1rem #000;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 320px;
    max-width: 100%;
}

.project-box img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: .5s ease;
    flex-shrink: 0;
}

.project-box:hover img{
   transform: scale(1.1);
}

.project-box .project-layer{
    position: absolute;
    overflow: hidden;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(rgba(0,0,0,0.6), #4c55f787);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
    text-align: center;
    padding: 0 4rem;
    transform: translateY(100%);
    transition: .5s ease;
}

.project-box:hover .project-layer{
    transform: translateY(0%);
}

.project-layer h4{
    font-size: min( 50px, 2rem);
    font-weight: 700;
    color: #fff;
}

.project-layer p{
    font-size: min(1rem, 15px);
    margin: .3rem 0 .1rem;
    color: #fff;
}

.project-layer .link-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 1.5rem;
    margin-top: 20px;
}

.project-layer .link-container a{
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    background-color: #ffffff;
    transition: .2s ease-in-out;
} 

.project-layer .link-container a:hover .link{
    color: #fff;
}

.project-layer .link-container a:hover{
    background-color: #00000088;
}

.project-layer .link-container a .link{
    transition: .3s ease-in-out;
    color: #000;
}



/* .project-layer .link-container .github{
    background-color: #000;
} */

.project-layer .link-container a i{
    color: #952b2b;
}

@media only screen and (max-width: 750px)
{
    
    .project-box .project-layer{
    position: absolute;
    overflow: hidden;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(rgba(0,0,0,0.6), #4c55f787);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    padding: 0 2rem;
    transform: translateY(100%);
    transition: .5s ease;
}

    .projects-container{
       margin-top: 50px;
       display: grid;
       grid-template-columns: repeat(1, 1fr);
       align-items: center;
       gap: 2.5rem;
    }

    .project-layer h4{
        font-size: 130%;
    }

    .project-layer p{
        font-size: 60%;
    }

    .project-box{
        border-radius: 1rem;
    }

}

</style>